import { Navigate, Route, Routes, useParams, useNavigate } from 'react-router-dom'
import Page from '../../components/layouts/page'
import Cycles from './cycles'
import { useQuery } from '@tanstack/react-query'
import { Button } from '@cinesend/ui-kit'
import Details from './details'
import Schemas from './schemas'
import ImageSpecs from './image_specs'
import { useState } from 'react'
import CreateCycleModal from './create_cycle_modal'

const Airline = () => {
  const params = useParams()
  const { data: airline, isLoading } = useQuery(['airlines/', params.airlineID])
  const [showCreateCycleModal, setShowCreateCycleModal] = useState(false)

  return (
    <Page
      pending={isLoading}
      breadcrumbs={[{ text: 'Airlines', to: '/settings/airlines' }, { text: airline?.name }]}
      tabs={[
        { name: 'Cycles', to: `cycles` },
        { name: 'Schemas', to: `schemas` },
        { name: 'Airline Details', to: `details` },
        { name: 'Image Specs', to: `image-specs` },
      ]}
      title={airline?.name}
      buttons={[
        <div key='airline_buttons' className='flex gap-2'>
          <Button onClick={() => setShowCreateCycleModal(true)}>Create cycle</Button>
        </div>,
      ]}
    >
      <Routes>
        <Route path='/cycles' element={<Cycles airlineID={params.airlineID} />} />
        <Route path='/schemas' element={<Schemas airline={airline} />} />
        <Route path='/details' element={<Details airline={airline} />} />
        <Route path='/image-specs' element={<ImageSpecs airline={airline} />} />
        <Route path='*' element={<Navigate to={`cycles`} replace={true} />} />
      </Routes>
      {showCreateCycleModal && (
        <CreateCycleModal airlineID={params.airlineID} closeModal={() => setShowCreateCycleModal(false)} />
      )}
    </Page>
  )
}

export default Airline
